@if (form) {
  <form [formGroup]="form">
    <mat-toolbar color="accent">
      <mat-toolbar-row>
        <button mat-button (click)="onClose()">
          <mat-icon aria-hidden="false" aria-label="Close">close</mat-icon>
          Close
        </button>
        <span class="toolbar-spacer"></span>
        <button mat-button [disabled]="!form.dirty" (click)="onReset()">
          <mat-icon aria-hidden="false" aria-label="Cancel">cancel</mat-icon>
          Cancel
        </button>
        <button mat-button [disabled]="!form.valid || !form.dirty" (click)="onSave()">
          <mat-icon aria-hidden="false" aria-label="Save">save</mat-icon> Save
        </button>
      </mat-toolbar-row>
    </mat-toolbar>
    <div class="sections">
      <section>
        <mat-form-field appearance="outline">
          <mat-label>Username</mat-label>
          <input matInput formControlName="username" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Full Name</mat-label>
          <input matInput formControlName="fullName" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>SAP ID</mat-label>
          <input matInput formControlName="sapId" />
        </mat-form-field>
      </section>
      <section>
        <h2>Access</h2>
        <table formArrayName="sitePermissions" width="100%">
          <thead>
            <tr>
              <th>Site</th>
              <th class="role-cell">Foreman</th>
              <th class="role-cell">Operator</th>
            </tr>
          </thead>
          <tbody>
            @for (sitePermission of sitePermissions.controls; track sitePermission; let i = $index) {
              <tr [formGroupName]="i">
                <td>
                  <span>{{ sitePermission.get('name').value }}</span>
                </td>
                <td class="role-cell" formGroupName="roles">
                  <mat-checkbox class="mat-checkbox-lg" formControlName="FOREMAN"></mat-checkbox>
                </td>
                <td class="role-cell" formGroupName="roles">
                  <mat-checkbox class="mat-checkbox-lg" formControlName="OPERATOR"></mat-checkbox>
                </td>
              </tr>
            }
          </tbody>
        </table>
        <mat-form-field>
          <mat-label>Select Project</mat-label>
          <mat-select
            class="project-selection"
            multiple
            [value]="selectedProjectIds"
            (selectionChange)="onProjectSelect($event.value)"
          >
            <mat-option *ngFor="let project of projects" [value]="project.id">
              {{ project.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <table class="project-selection" width="100%">
          <thead>
            <tr>
              <th colspan="2">Selected Projects</th>
            </tr>
          </thead>
          <tbody>
            @for (project of selectedProjects; track project.id) {
              <tr>
                <td>{{ project.name }}</td>
                <td>
                  <button mat-icon-button (click)="removeProject(project.id)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    </div>
  </form>
} @else {
  Loading User...
}
